<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="banner-title">
                    <div class="title">
                        <h1>無料オンライン英文チェックツール
                        </h1>
                    </div>
                    <p>AI 搭載の英文チェックツールTrinka（トリンカ）で、複雑な文法ミスの検出を含む、リアルタイムの英文チェックをご体験ください。<br/>
                        Trinkaの英文チェックツールなら、文法の誤りを修正するだけでなく、文構造や句読点などが正しいかもチェックします。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                    </ul>
                    <app-english-grammar-checker></app-english-grammar-checker>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="trinka-banner section-pd-sm d-lg-block d-none" id="real-time">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinkaのプラグインで、どこでも正確な英文ライティングを</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a  id="GCChromeButton1" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" class="white-btn"><img src="assets/images/NewChromeIcon.svg" width="32" height="32" alt="chrome - 文法チェッカー"> Download for Chrome</a>
                    <a  id="GCFirFoxButton1" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="white-btn"><img src="assets/images/NewFirefoxIcon.svg" width="32" height="32" alt="firefox - 文法チェッカー"> Download for Firefox</a>
                    <a  id="GCEdgeButton1" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank" class="white-btn"><img src="assets/images/EdgeWhite_BGAndOutline.svg" width="32" height="32" alt="edge - 文法チェッカー"> Download for Edge</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="signupmobile trinka-banner section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">無料アカウントで<br>もっとチェック！</h3>
                    <p class="text-white">Trinkaへのご登録で、毎月5千単語まで英文チェックが無料。文法、スペル、文体の精度向上にご活用ください。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">今すぐ登録する</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0">
                    <h2>高性能な無料オンライン英文チェックツール</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>無料オンライン英文チェックツールTrinkaは、文法的に正しく分かりやすい英文執筆をサポートします。 </p>
                    <p>Trinkaは、文構造や言葉遣いの問題をリアルタイムで修正。語順の誤りやスぺルミスなどを瞬時に識別し、正しい代替案を提案します。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>高度な英文チェックと修正提案</li>
                            <li><a [routerLink]="['/grammar-checker']">精度の高い文法チェック</a></li>
                            <li>ご利用は無料</li>
                            <li>文脈に応じたスペルチェック</li>
                        </ul>
                    </div>
                    <p>オンライン英文チェックツールTrinkaはミスを検出し、より理解しやすいよう、解説付きの修正案を提案します。</p>
                    <p>アカウント登録いただければ、Trinkaのより多くの機能を無料でお使いいただけます。</p>
                    <div class="btn-group">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="filled-btn">さっそく始める</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">Trinkaの
                        英文チェックツールは
                        誰に向いている？ </h3>
                    <p class="text-white">どなたでもTrinkaの高度な英文チェック機能をお使いいただけます。学生、研究者、著者、フリーランスのコンテンツライター、ブロガーなど、英文執筆の機会のあるすべての方の、あらゆるタイプの英語ライティングを支援します。</p>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="the_best_grammer_sections section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>英文チェックツールTrinkaの主な機能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>構文</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、明確で読みやすい英文になるよう、正しい構文や語順になっているか、欠落している単語がないかをチェックします。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>Coelomic fluid samples were <span class="wrong_text">analyzed</span>&nbsp;<span class="right_text"> analyzed using</span> various tools.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高度な文法チェック</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、基本的な文法ミスの検出やスペルチェックにとどまらず、複雑な文法ミスを検出し、英文の質を向上させる改善案を提案します。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Neither the healthy individuals nor the patient <span
                                class="wrong_text">recognize</span> <span
                                class="right_text"> recognizes</span> the visual discrepancies.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>語法と文体</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinkaは、不正確な語彙や偏向のある語彙を検出して適切な言葉を提案し、正確で偏りのない、読者に響くフォーマルな英文ライティングを実現します。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>However, this method is novel and is
                                <span class="wrong_text">very much</span>&nbsp;
                                <span class="right_text">considerably</span> different from the classical method.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>句読点・スペルチェック</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>文章や文法のチェックに加え、Trinkaは句読点も改善。より読みやすい英文に仕上げます。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p><span class="wrong_text">Importantly</span>&nbsp;<span
                                class="right_text">Importantly,</span> there were no <span class="wrong_text">observble</span>&nbsp;
                                <span class="right_text">observable</span>
                                adverse effects</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="use_trinka_other_app section-pd-sm">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white">プラグイン・アドインで、
                        いつでもどこでも
                        良質なライティングを</h3>
                </div>
                <div class="use_trinka_content">
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud - 文法チェッカー">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/wordAdd-in1.svg" alt="word - 文法チェッカー">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewChromeIcon.svg" alt="chrome - 文法チェッカー">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewFirefoxIcon.svg" alt="firefox - 文法チェッカー">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="edge - 文法チェッカー">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/safari_logo.png" alt="safari - 文法チェッカー">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>無料英文チェックツールの機能はどんなもの？</h3>
                    <p>Trinkaの英文チェックツールに搭載された人工知能（AI）は、様々な分野の膨大な数の優れた研究論文から学習しています。文章、文構造、言い回し、語順、用法をチェックし、その分野や文脈において正しい、精度の高い英文にします。使い方も簡単。英文を入力するだけで、細かなミスの修正から複雑な変更まで提案し、英語の文章を短時間で校正できます。</p>
                    <p>Trinkaを使えば、文中のあらゆる種類の文法やスペルの誤り修正し、自信を持ってコミュニケーションをとることができます。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="assets/images/WritingMoreEffective.png" alt="文法チェッカー">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>なぜTrinkaの英文チェックツールが選ばれるのか？</h3>
                    <p>AI搭載の英文チェックツールTrinkaは、文法ミス、句読点ミス、スペルミスなど、文章内の問題を洗い出します。最新の機械学習（ML）と自然言語処理（NLP）技術を使用して開発されており、正確な提案を行います。</p>
                    <p>AI英文校正ツールTrinkaを使用して時間を大幅に節約することで、メッセージや理論の明確な伝達など、ライティングのより深い部分に集中できます。Trinkaは、複雑な専門用語を扱うテクニカルライティングなどを含む、あらゆるタイプの英文ライティングで効果を発揮します。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <img src="assets/images/LearnGrammarwithTrinka.png" alt="文法チェッカー">
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="testimonial-section text-center section-pd">
    <app-testimonial></app-testimonial>
</div>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h3 class="text-white mb-4">AI英文チェックツールTrinkaで質の高い英文ライティングを</h3>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <!-- <i class="fa fa-sign-in"></i> -->
                            <span>無料登録する</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div> 

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>Trinka英文チェックツールについてよくあるご質問</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCOneContent" aria-expanded="true"
                                        aria-controls="QuestionGCOneContent">
                                        自分の文章が正しいかどうか、どうすればチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCOneContent" class="collapse"
                                    aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>このページの冒頭にある入力枠に英文を貼り付け、「修正結果を見る」をクリックするだけです。Trinkaがすべての文型と用法の誤りをハイライトし、文脈に応じた的確な提案をします。</p>
                                    </div>
                                </div>
                            </div>        
                            
                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent">自分が書いた英文の文法チェックを行うにはどうすればいいですか？</a>
                                </div>
    
                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>AI英文チェックツールTrinkaを使えば、わずか数クリックで、文法や句読点の間違い、単語の用法などがチェックでき、英文の見直しが可能です。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">

                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent">Trinkaの英文チェックツールは無料で使えますか？</a>
                                </div>
    
                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>もちろんです。このページ冒頭の入力枠に英文を貼り付けて「修正結果を見る」をクリックすると、英語の文章をチェックしたり修正したりできます。300単語以上の英文をチェックしたい場合は、<a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="text-link">Trinkaにご登録</a>、より多くの機能を無料でご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">ウェブサイトの英文をチェックできますか？</a>
                                </div>
    
                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい、できます。Chrome、Firefox、Edge<a [routerLink]="['/browser-plugin']" class="text-link">ブラウザプラグインをインストール</a>、どのウェブサイトでもTrinkaを使うことができます。</p>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>